/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /*!******************************************************!*\
  !*** ./resources/js/modules/sections/page-slider.js ***!
  \******************************************************/
  document.addEventListener('DOMContentLoaded', function () {
    var swiperReviews = new window.swiper('.js-page-slider', {
      slidesPerView: 1,
      direction: 'horizontal',
      loop: true,
      effect: 'fade',
      pagination: {
        el: '.js-page-slider .swiper-pagination',
        clickable: true,
      },
    });
  });
  /******/
})();
